export const getErrorMessageFromResponse = (err) => {
  if (!err) return 'Unknown error occurred';

  const res = err.response || err;

  const resData = res && res.data;
  if (!resData) {
    return err.message || 'Unknown error occurred';
  }
  if (Array.isArray(resData.errors) && resData.errors.length > 0) {
    return resData.errors[0].message || 'An error occurred';
  }
  if (resData.message) return resData.message;
  if (resData.error) return resData.error;
  if (typeof resData.data === 'string') return resData.data;
  return err.message || 'An unknown error occurred';
};
